/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpinWithFullGame } from './SpinWithFullGame';
import {
    SpinWithFullGameFromJSON,
    SpinWithFullGameFromJSONTyped,
    SpinWithFullGameToJSON,
} from './SpinWithFullGame';
import type { SpinHistoryFilters } from './SpinHistoryFilters';
import {
    SpinHistoryFiltersFromJSON,
    SpinHistoryFiltersFromJSONTyped,
    SpinHistoryFiltersToJSON,
} from './SpinHistoryFilters';
import type { SpinHistoryResultRange } from './SpinHistoryResultRange';
import {
    SpinHistoryResultRangeFromJSON,
    SpinHistoryResultRangeFromJSONTyped,
    SpinHistoryResultRangeToJSON,
} from './SpinHistoryResultRange';

/**
 * 
 * @export
 * @interface SpinHistoryAdminPage
 */
export interface SpinHistoryAdminPage {
    /**
     * 
     * @type {Array<SpinWithFullGame>}
     * @memberof SpinHistoryAdminPage
     */
    results: Array<SpinWithFullGame>;
    /**
     * 
     * @type {number}
     * @memberof SpinHistoryAdminPage
     */
    totalResults: number;
    /**
     * 
     * @type {SpinHistoryFilters}
     * @memberof SpinHistoryAdminPage
     */
    filters: SpinHistoryFilters;
    /**
     * 
     * @type {SpinHistoryResultRange}
     * @memberof SpinHistoryAdminPage
     */
    resultRange?: SpinHistoryResultRange | null;
}

/**
 * Check if a given object implements the SpinHistoryAdminPage interface.
 */
export function instanceOfSpinHistoryAdminPage(value: object): value is SpinHistoryAdminPage {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('filters' in value) || value['filters'] === undefined) return false;
    return true;
}

export function SpinHistoryAdminPageFromJSON(json: any): SpinHistoryAdminPage {
    return SpinHistoryAdminPageFromJSONTyped(json, false);
}

export function SpinHistoryAdminPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinHistoryAdminPage {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(SpinWithFullGameFromJSON)),
        'totalResults': json['totalResults'],
        'filters': SpinHistoryFiltersFromJSON(json['filters']),
        'resultRange': json['resultRange'] == null ? undefined : SpinHistoryResultRangeFromJSON(json['resultRange']),
    };
}

export function SpinHistoryAdminPageToJSON(value?: SpinHistoryAdminPage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(SpinWithFullGameToJSON)),
        'totalResults': value['totalResults'],
        'filters': SpinHistoryFiltersToJSON(value['filters']),
        'resultRange': SpinHistoryResultRangeToJSON(value['resultRange']),
    };
}

